import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constant } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class WhatsAppContactGroupService {


  url = environment.serverAPI8 + "/api/contactGroup";

  ur2 = environment.serverAPI8 + "/api/createCampaignTemplate";

  constructor(private http: HttpClient) { }

  getAllContactGroup(): Observable<Object> {
    return this.http.get(`${this.url}`);
  }

  getAllCreateCampaignTemplate(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllContactGroupDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }
  deleteProcess(uid: string): Observable<any> {
    // const params = new HttpParams().set('vendorId', vendorId);

    return this.http.delete<any>(`${this.url}/${uid}/delete-process`);
  }

  deleteGroup(contactGroupId: number): Observable<any> {
    return this.http.delete<any>(`${environment.serverAPI8}/api/groups/${contactGroupId}/delete`);
  }

  // productNotLinkedSearch(linkedProduts,Page: number, size: number, sort: any): Observable<Response[]> {
  // 	return this.http.post<Response[]>(`${this.url}/linked/search?page=${Page}&size=${size}&sort=${sort}`, linkedProduts);
  // }

  getAllContactGroupById(contactGroupId: number): Observable<Object> {
    return this.http.get(`${this.url}/${contactGroupId}`);
  }

  /**
   * Get contact group metadata plus paginated contacts (server-side)
   */
  getContactGroupWithContacts(contactGroupId: number, page: number, size: number, sort: string): Observable<Object> {
    return this.http.get(`${this.url}/${contactGroupId}/contacts?page=${page}&size=${size}&sort=${sort}`);
  }

  getContactGroup(contactGroupId: number): Observable<Object> {
    return this.http.get(`${this.url}/${contactGroupId}/group`);
  }

  /** Add contacts to a contact group (bulk) */
  addContactsToGroup(contactGroupId: number, contacts: any[]): Observable<Object> {
    return this.http.post(`${this.url}/${contactGroupId}/contacts`, contacts);
  }

  /** Remove a contact from a contact group */
  removeContactFromGroup(contactGroupId: number, contactId: number): Observable<Object> {
    return this.http.delete(`${this.url}/${contactGroupId}/contacts/${contactId}`);
  }

  addOrEditContactGroup(dynamicformgroup: any): Observable<Response[]> {

    let params = new HttpParams();

    // if (vendorId != null) {
    //   params = params
    //     .set('vendorId', vendorId.toString());
    // }

    return this.http.post<Response[]>(`${this.url}`, dynamicformgroup);
  }

  // contactGroupSearch(query, Page: any, size: any, sort: any): Observable<Object> {
  //   return this.http.get(`${this.url}/condition?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  // }

  contactGroupSearch(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters


    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  contactNotLinked(linkedDynamic, vendorId: number, Page: number, size: number, sort: any): Observable<Object> {
    return this.http.post<Response[]>(`${this.url}/linked/?vendorId=${vendorId}&page=${Page}&size=${size}&sort=${sort}`, linkedDynamic);
  }

  customerNotLinked(linkedDynamic, Page: number, size: number, sort: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/linked?page=${Page}&size=${size}&sort=${sort}`, linkedDynamic);
  }

  contactNotLinkedSearch(linkedProduts, Page: number, size: number, sort: any): Observable<Response[]> {

    return this.http.post<Response[]>(`${this.url}/linked/search?page=${Page}&size=${size}&sort=${sort}`, linkedProduts);
  }

  isLoading = new Subject<boolean>();

  show() {
    this.isLoading.next(true);

  }

  uploadContactGroups(payload: unknown): Observable<any> {
    return this.http.post<any>(`${this.url}/bulk/import`, payload);
  }


  contactGroupSearchContactSerach(query: string, page: number, size: number, sort: string, contactGroupId: number,): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters


    return this.http.post<Response[]>(`${this.url}/${contactGroupId}/contacts/condition${queryParams}`, requestBody);
  }

}
